import PadraoModel from 'src/core/model/PadraoModel.js'

export default class IcarrosMarcaModel extends PadraoModel {
  recurso = 'icarros/marcas';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Marcas Icarros';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
